
import Vue, { PropType } from 'vue';
import { RUNNIT_TYPE } from '@run-diffusion/shared';

export default Vue.extend({
	name: 'RunnitBoardSkeleton',
	props: {
		runnitType: {
			type: String as PropType<string | null>,
			default: null,
		},
	},
	computed: {
		isSingleTool (): boolean {
			return this.runnitType === RUNNIT_TYPE.SINGLE_TOOL;
		},
		isTemplate (): boolean {
			return this.runnitType === RUNNIT_TYPE.TEMPLATE;
		},
		cardCount (): number {
			return this.isSingleTool ? 1 : 2;
		},
		eyebrowText (): string {
			return this.isTemplate ? 'Loading template' : 'Loading board';
		},
		ariaLabel (): string {
			if (this.isSingleTool) return 'Loading tool';
			if (this.isTemplate) return 'Loading template';
			return 'Loading board';
		},
	},
});
